import React from 'react';
import Cleave from 'cleave.js/react';
import css from './CustomInputField.module.scss';

export default function CustomCleaveField(props) {
  const {
    placeholder,
    innerPlaceholder,
    format,
    secondaryFormat,
    options,
    error,
    toggle,
    onChange,
    onBlur,
    icon,
    disabled,
    allowFullStory,
    id,
    rawValue,
    setAdvocateRole,
    ...rest
  } = props;

  const onChangeValue = event => {
    const value = rawValue ? event.target.rawValue : event.target.value;
    onChange(value);
  };

  const onBlurValue = event => {
    if (onBlur) {
      const value = rawValue ? event.target.rawValue : event.target.value;
      onBlur(value);
    }
  };

  return (
    <div
      className={`${css.field} ${css.CustomInputFieldGroup} ${
        !allowFullStory && 'fs-mask'
      }`}
    >
      <div className={css.inputGroup}>
        <label htmlFor={id}>{placeholder}</label>
        <Cleave
          {...rest}
          id={id}
          onChange={onChangeValue}
          onBlur={onBlurValue}
          options={options}
          disabled={disabled}
          placeholder={innerPlaceholder}
        />
        <span
          className={`${css.bar} ${disabled ? css.disabled : ''} ${
            error ? css.error : ''
          }`}
        />
        {!toggle && error && (
          <img
            className={css.errorIcon}
            src="/static/error-icon.svg"
            alt="Input Error Icon"
          />
        )}
      </div>
      <span
        className={`${css.formatLabel} ${error ? css.error : ''}`}
        data-e2e={error ? 'error-message' : 'input-format'}
      >
        {format}
      </span>
      <span className={css.formatLabel} data-e2e={'input-secondary-format'}>
        {secondaryFormat}
      </span>
      {toggle && error && (
        <div style={{ height: '45px' }}>
          <img
            className={css.dobErrorIcon}
            src="/static/error-icon.svg"
            alt="Input Error Icon"
          />
          <p className={css.redFormatLabel} data-e2e="gender-label">
            Enter a valid birthdate (MM/DD/YYYY)
          </p>
        </div>
      )}
      {!!icon && icon}
    </div>
  );
}
